<script setup lang="ts">
import { ref, toRefs } from "vue";

const props = defineProps<{
  buttonText: string;
  armedText: string;
}>();
const emit = defineEmits<{
  (e: "click"): void;
  (e: "armed"): void;
}>();

const { buttonText, armedText } = toRefs(props);
const state = ref("normal");
const arm = () => {
  state.value = "armed";
  emit("armed");
};
const click = () => {
  emit("click");
};
</script>
<template>
  <pn-toast
    v-show="state === 'armed'"
    closable="false"
    appearance="error"
    :text="armedText"
  ></pn-toast>
  <span v-show="state === 'armed'">|</span>
  <pn-button
    v-show="state === 'normal'"
    small="true"
    v-on:click="arm"
    :label="buttonText"
  ></pn-button>
  <pn-button
    v-show="state === 'armed'"
    small="true"
    v-on:click="click"
    label="Yes"
  ></pn-button>
</template>
